module.exports = __webpack_public_path__ + "img/horizontal_6_5_5012.c79171a9.png";